import styled from "styled-components";
import { Text } from "../components/typography/Texts";
import { BaseScreen } from "../components/baseScreen/BaseScreen";
import { ErrorCard } from "./ErrorScreen";
import { colors } from "@permisso/permisso-components";

const NOT_FOUND_DESCRIPTION = "Error 404";

export const NotFoundErrorScreen = () => {
  return (
    <BaseScreen backgroundColor={colors.grey0}>
      <Layout>
        <ErrorCard />
        <Text>{NOT_FOUND_DESCRIPTION}</Text>
      </Layout>
    </BaseScreen>
  );
};

const Layout = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1.5rem;
`;
